import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Text } from '@uhg-abyss/web/ui/Text';

import { mobileOnly, notMobile, tabletOnly } from '../../ConstantsStyles';

export const SectionHeadingRow = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '4px',
});

export const CardContainer = styled('div', {
  border: '1px solid $info1',
  borderRadius: '8px',
  padding: '$md',
  backgroundColor: 'white',
  boxShadow: '0 4px 2px rgba(0, 0, 0, 0.08)',
  width: '100%',
  minHeight: '130px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '$md',
  marginBottom: '$lg',
  [`@media ${tabletOnly}`]: {
    marginBottom: '20px',
    minHeight: '120px',
    padding: '14px',
    gap: '12px',
    width: '100%',
  },
  [`@media ${mobileOnly}`]: {
    marginBottom: '16px',
    minHeight: 'auto',
    padding: '12px',
    width: '100%',
    marginLeft: '12px',
  },
});

export const containerCss = {
  [`@media ${notMobile}`]: { marginBottom: '-24px' },
  [`@media ${mobileOnly}`]: { marginBottom: '-20px' },
};

export const SectionMessageText = styled(Text, {
  '&.abyss-text-root': {
    lineHeight: '140%',
    fontWeight: '$semibold',
  },
});

export const CompareProviderTypesButton = styled(Button, {
  '&.abyss-button-root': {
    borderRadius: '24px',
    fontWeight: '700',
    fontFamily: '$primary',
    width: 'fit-content',
    '&:active': {
      backgroundColor: '$primary1',
      color: 'white',
      borderColor: '$primary1',
    },
  },
  '.abyss-button-content-container': {
    height: '32px',
    padding: '4px 16px',
  },
});

CompareProviderTypesButton.defaultProps = {
  size: 'small',
  variant: 'outline',
};
